module.exports = __webpack_public_path__ + "static/media/list.2f5a1220.svg";